import SignIn from './SignIn'

const VippsCallback = () => <SignIn />

export default VippsCallback
